import { captureException } from '@sentry/browser';

export interface BlockFormatFlags {
  hasCodeBlock: boolean;
  hasOrderedList: boolean;
  hasUnorderedList: boolean;
}

const emptyFlags = (): BlockFormatFlags => ({
  hasCodeBlock: false,
  hasOrderedList: false,
  hasUnorderedList: false,
});

/**
 * Detects Quill block formats in an HTML string: code blocks (`<pre>`), ordered
 * lists (`<ol>`) and unordered lists (`<ul>`). Quill 1.3.x emits semantic list
 * tags, so plain tag selectors are sufficient.
 */
export function getBlockFormats(htmlString: string): BlockFormatFlags {
  try {
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return {
      hasCodeBlock: doc.querySelector('pre') != null,
      hasOrderedList: doc.querySelector('ol') != null,
      hasUnorderedList: doc.querySelector('ul') != null,
    };
  } catch (e) {
    captureException(e);
    return emptyFlags();
  }
}
